import axiosTokenService from "./axiosTokenService";
import { cloud_url, final_url } from "./Configuration";
import { housing_url } from "./Configuration";
import { LOGIN_API_URL } from "./loginConfiguration";
import axiosWithOutToken from "../Components/axiosWithOutToken";
import axiosTokenServiceKeyCloak from "./axiosTokenServiceKeyCloak";
require("dotenv").config();
class HousingService {
  loginDetails(apofmslogin) {
    return axiosWithOutToken.post(LOGIN_API_URL, apofmslogin);
  }
  // housingLoginDetails(apofmslogin){
  //   return axiosWithOutToken.post(LOGIN_API_URL,apofmslogin)
  // }

  changePassword(params) {
    return axiosTokenService.post(final_url + "changePassword", params);
  }
  changeUsername(params) {
    return axiosTokenService.post(final_url + "changeUsername", params);
  }

  //Rani
  DashBoardBankDetails() {
    return axiosTokenService.get(final_url + "DashBoardBankDetails");
  }
  getBankOpening_balanceDashboard() {
    return axiosTokenService.get(final_url + "getBankOpening_balanceDashboard");
  }

  // getServices() {
  //   return axiosTokenService.post(final_url + "getServices");
  // }
  getServices() {
    return axiosTokenService.post(final_url + "getParentServices");
  }
  // getReports() {
  //   return axiosTokenService.post(final_url + "getReports");
  // }

  getReports() {
    return axiosTokenService.post(final_url + "getParentReports");
  }


  getPayrollReports() {
    return axiosTokenService.post(final_url + "getParentPayrollReports");
  }

  BRSServices() {
    return axiosTokenService.post(final_url + "BRSServices");
  }
  AuditServices() {
    return axiosTokenService.post(final_url + "AuditServices");
  }

  getBRSForms() {
    return axiosTokenService.post(final_url + "getBRSForms");
  }
  getManagerApproveForms() {
    return axiosTokenService.post(final_url + "getParentApprovals");
  }
  getHousingReports() {
    return axiosTokenService.post(final_url + "getHousingReports");
  }
  getGeneralServices() {
    return axiosTokenService.post(final_url + "getGeneralServices");
  }
  getAdminServices() {
    return axiosTokenService.post(final_url + "getAdminServices");
  }
  //ADD SERVICE
  addserviceslist() {
    return axiosTokenService.get(final_url + "getServicesList"); //Add Service by sevlal
  }

  parentidlist() {
    return axiosTokenService.get(final_url + "getParentIDsList"); //Add Service by sevlal
  }

  submitService(param) {
    return axiosTokenService.post(final_url + "insertServicesDetails", param); //Add Service by sevlal
  }

  deleteData(service_id) {
    return axiosTokenService.post(
      final_url + "deleteService?service_id=" + service_id
    );
  }

  updateDeatil(params) {
    return axiosTokenService.put(final_url + "updateServices", params);
  }

  editData(service_id) {
    return axiosTokenService.get(
      final_url + "getEditServiceData?service_id=" + service_id
    );
  }
  //ROLE MAPPING
  getRolesList() {
    return axiosTokenService.get(final_url + "getRolesList");
  }

  getServicesListWithRoleID(roleid) {
    return axiosTokenService.get(
      final_url + "getServicesListWithRoleID?role_id=" + roleid
    );
  }

  RoleServiceMapping(params) {
    return axiosTokenService.post(final_url + "insertRolesServices", params);
  }
  //ENTRY FORMS*******
  //BANK ENTRY SCREEN

  fetchDistrictNames() {
    return axiosTokenService.get(final_url + "getLoggedUser");
  }



  // createBankEntryForm(formData) {
  //   return axiosTokenService.post(
  //     final_url + "Bank_Details_Entry_Insertion",
  //     formData
  //   );
  // }
  createBankEntryForm(params) {
    return axiosTokenService.post(
      final_url + "bankDetailsEntryInsertion",
      params
    );
  }
  BankEntryMangerApproval(formData) {
    return axiosTokenService.post(
      final_url + "bankEntryManagerApproval",
      formData
    );
  }
  BankEntryMangerReject(params) {
    return axiosTokenService.post(final_url + "bankEntryManagerReject", params);
  }
  //Receipt Entry

  getPaymentReceiptId(params) {
    return axiosTokenService.post(
      final_url + "generatePaymentReceiptId",
      params
    );
  }

  fetchBank() {
    return axiosTokenService.get(
      final_url + "Bank_Name_And_Account_No_DropDown"
    );
  }

  fetchHeadNamesDropdowns() {
    return axiosTokenService.get(final_url + "HeadNames");
  }
  fetchHeadNamesPaymentsDropdowns() {
    return axiosTokenService.get(final_url + "HeadNamesPayments");
  }

  fetchSubHeadName(headid) {
    return axiosTokenService.get(final_url + "SubHeadNames/" + headid);
  }
  fetchSubHeadNameForEdit(selectedHeadIds) {
    return axiosTokenService.get(final_url + "SubHeadNames/" + selectedHeadIds);
  }
  Generation_Receipt_Insertion(params) {
    return axiosTokenService.post(
      final_url + "generationReceiptInsertion",
      params
    );
  }
  Payment_Receipts_Managerreject(params) {
    return axiosTokenService.post(
      final_url + "paymentReceiptsManagerReject",
      params
    );
  }
  Payment_Receipts_ManagerRemoveRow(params) {
    return axiosTokenService.post(
      final_url + "paymentReceiptsManagerRemoveRow",
      params
    );
  }
  getRecieptPdf(payment_receipt_id) {
    return axiosTokenService.get(final_url + "trailBalacePdf", {
      responseType: "blob",
      params: { payment_receipt_id: payment_receipt_id }
    });
  }
  //Payment Entry

  getPaymentPdf(payment_receipt_id) {
    return axiosTokenService.get(final_url + "trailBalacePdf", {
      responseType: "blob",
      params: { payment_receipt_id: payment_receipt_id }
    });
  }

  BalanceSheetPDF(type, security_id, fromDate, toDate) {
    return axiosTokenService.get(final_url + "BalanceSheetPDF", {
      responseType: "blob",
      params: {
        type: type,
        security_id: security_id,
        fromDate: fromDate,
        toDate: toDate

      }
    });
  }

  ProfitandLossPDF(type) {
    return axiosTokenService.get(final_url + "ProfitandLossPDF", {
      responseType: "blob",
      params: { type: type }
    });
  }


  Generation_Payment_Insertion(params) {
    return axiosTokenService.post(
      final_url + "Generation_Payment_Insertion",
      params
    );
  }
  headsNameApi() {
    return axiosTokenService.get(final_url + "HeadNames");
  }

  //Journal

  Generation_Journal_Insertion(params) {
    return axiosTokenService.post(
      final_url + "Generation_Journal_Insertion",
      params
    );
  }
  Journal_Voucher_Edit(params) {
    return axiosTokenService.post(
      final_url + "Journal_Voucher_Edit",
      params
    );
  }
  salaryGenerationJournalInsertion(params) {
    return axiosTokenService.post(
      final_url + "salaryGenerationJournalInsertion",
      params
    );
  }
  Generation_Journal_reject(params) {
    return axiosTokenService.post(
      final_url + "Generation_Journal_reject",
      params
    );
  }
  RowRemoveApi(params) {
    return axiosTokenService.post(
      final_url + "Generation_Journal_RowDelete",
      params
    );
  }


  //Inter Bank  Transfer

  InterBankTransferInsertion(params) {
    return axiosTokenService.post(
      final_url + "InterBankTransferInsertion1",
      params
    );
  }
  // getinerbankPdf(transactionId, receipt_id) {
  //   return axiosTokenService.get(final_url + "interbanktransferpdf", {
  //     responseType: "blob",
  //     params: { payment_receipt_id: transactionId, receipt_id: receipt_id }
  //   });
  // }
  getinerbankPdf(transactionId, receipt_id) {
    return axiosTokenService.get(final_url + `interbanktransferpdf1?payment_receipt_id=${transactionId}&receipt_id=${receipt_id}`, { responseType: "blob", });
  }
  Bank_AC_Bal(params) { return axiosTokenService.post(final_url + "Bank_AC_Bal", params); }
  //Cadre


  fetchdist() {
    return axiosTokenService.get(final_url + "getLoggedUser");
  }
  getcadredistlist(params) {
    return axiosTokenService.post(
      final_url + "getCadreWiseDistDivManDropdowns",
      params
    );
  }
  getCadreWiseCasteDropdownlist() {
    return axiosTokenService.get(final_url + "getCadreWiseCasteDropdown");
  }

  getCadreWiseDesignationDropdownlist() {
    return axiosTokenService.get(final_url + "getCadreWiseDesignationDropdown");
  }
  getCadreWiseRegulardeputationDropdown() {
    return axiosTokenService.get(
      final_url + "getCadreWiseRegular_deputationDropdown"
    );
  }

  getCadreWiseQualificationDropdown() {
    return axiosTokenService.get(
      final_url + "getCadreWiseQualificationDropdown"
    );
  }



  getbasicdetails(param) {
    return axiosTokenService.post(
      final_url + "getCadreWiseDetailsByEmpID",
      param
    );
  }
  getpromotionsdata(params) {
    return axiosTokenService.post(
      final_url + "getCadreWiseDetailsByEmpID_SubsequentPromotions",
      params
    );
  }
  getinspection(param1) {
    return axiosTokenService.post(
      final_url + "getCadreWiseDetailsByEmpID_POWI",
      param1
    );
  }
  AddNewEmpid() {
    return axiosTokenService.get(final_url + "AddNewEmpid");
  }
  fetchBankName() {
    return axiosTokenService.get(final_url + "Name_Of_The_Bank_DropDown");
  }
  // fetchBankName() {
  //   return axiosTokenService.get(final_url + "Name_Of_The_Bank_DropDown");
  // }
  updateSubsequentPromotion(empid) {
    return axiosTokenService.get(
      final_url +
      "getCadreWiseDetails_Edit_ByEmpID_SubsequentPromotions?empid=" +
      empid
    );
  }
  Edit_Subsequent_Promotion_Add(params1) {
    return axiosTokenService.post(
      final_url + "Edit_Subsequent_Promotion_Add",
      params1
    );
  }

  Edit_Placeofworkingfrominception_Add(params2) {
    return axiosTokenService.post(
      final_url + "Edit_Placeofworkingfrominception_Add",
      params2
    );
  }
  submitnewemployeedetails(params) {
    return axiosTokenService.post(
      final_url + "Add_button_insert_cadreWise",
      params
    );
  }
  // submitnewemployeedetails(params) {
  //   return axiosTokenService.post(
  //     final_url + "Add_button_insert_cadreWise",
  //     params
  //   );
  // }

  //   getcadredistlist(params) {
  //   return axiosTokenService.post(
  //     final_url+"getCadreWiseDistDivManDropdowns",
  //     params
  //   );
  // }

  // getTable1(dist_code) {
  //   return axiosTokenService.get(
  //     final_url + "getCadreWiseData?dist_code=" + dist_code
  //   );
  // }


  // getTable1() {
  //   return axiosTokenService.get(final_url + "getCadreWiseData");
  // }

  // getCadreWiseRegulardeputationDropdown() {
  //   return axiosTokenService.get(
  //     final_url + "getCadreWiseRegular_deputationDropdown"
  //   );
  // }




  //http://172.17.205.53:8082/ofmsapi/getCadreWiseDistDivManDropdowns

  getcadredivlist(dist_code) {
    return axiosTokenService.post(
      final_url +
      "getCadreWiseDistDivManDropdowns?dist_code=" +
      dist_code +
      "&div_code=0&sdiv_code=0"
    );
  }
  //Subheadmaster
  HeadNames() {
    return axiosTokenService.get(final_url + "HeadNames");
  }
  CGG_District() {
    return axiosTokenService.get(final_url + "CGG_District");
  }

  GetSubHeadsData(params) {
    return axiosTokenService.post(final_url + "GetSubHeadsData", params);
  }
  rowUpdate(params) {
    return axiosTokenService.put(final_url + "EditSubheads", params);
  }
  rowdel(requestBody) {
    return axiosTokenService.put(final_url + "DeleteSubheads", requestBody);
  }
  rowinsert(params) {
    return axiosTokenService.post(final_url + "AddSubheads", params);
  }
  //Online
  fetchJournalVoucherList() {
    return axiosTokenService.get(final_url + "getVoucherListDropdown");
  }

  fetchJournalVoucherDescription(voucher_id) {
    return axiosTokenService.get(
      final_url + "getDescription_Heads/" + voucher_id
    );
  }

  //Slaary

  fetchSalaryJVDescription(voucher_id) {
    return axiosTokenService.get(
      final_url + "getDescription_Heads/" + voucher_id
    );
  }
  fetchSalaryJVList() {
    return axiosTokenService.get(final_url + "getSalaryVoucherListDropdown");
  }

  ClassificationBudget() {
    return axiosTokenService.get(final_url + "ClassificationBudget");
  }
  createOnlineJVForm(params) {
    return axiosTokenService.post(final_url + "journalvocherinsertion", params);
  }

  //Reports

  //Bank  Book Report
  BankBookTable(params) {
    return axiosTokenService.post(final_url + "GetBankBook_Report", params);
  }
  //Bank Subsidary
  GetSubsidiary_Report(params) {
    return axiosTokenService.post(final_url + "GetSubsidiary_Report", params);
  }
  getBankOpening_balance(params) {
    return axiosTokenService.post(final_url + "getBankOpening_balance", params);
  }
  //SEARCH EMPLOYEE
  getSearchEmployeeTable(params) {
    return axiosTokenService.post(
      final_url + "GetSearchEmployee_Report",
      params
    );
  }
  //Cash/Bank Receipts &Receipts
  getCashBankRecipetsData(params) {
    return axiosTokenService.post(
      final_url + "GetCashBank_Receipts_PaymentsReport",
      params
    );
  }

  //Cash/Bank Receipts &Receipts
  GetCashBankRPHeads(params) {
    return axiosTokenService.post(
      final_url + "GetCashBankRPHeads",
      params
    );
  }

  getRecipetTableData(payment_receipt_id) {
    return axiosTokenService.get(
      final_url +
      "Get_PaymentReceiptId?payment_receipt_id=" +
      payment_receipt_id
    );
  }

  //Rani added
  GetHeadsTable(payment_receipt_id) {
    return axiosTokenService.get(
      final_url +
      "Get_PaymentReceiptId_Heads?payment_receipt_id=" +
      payment_receipt_id
    );
  }
  ReceiptEntryPdf(payment_receipt_id) {
    return axiosTokenService.get(final_url + "trailBalacePdf", {
      responseType: "blob",

      params: { payment_receipt_id: payment_receipt_id }
    });
  }
  //JOURNAL VOUCHER
  GetJournalVochersReport(params) {
    return axiosTokenService.post(
      final_url + "GetJournalVochersReport",
      params
    );
  }

  GetJournalVochersHeadsReport(params) { return axiosTokenService.post(final_url + "GetJournalVochersHeadsReport", params); }

  CheckReceipNo(params) { return axiosTokenService.post(final_url + "CheckReceipNo", params); }





  GetJournalVochersReport_DataById(params) {
    return axiosTokenService.post(
      final_url + "GetJournalVochersReport_DataById",
      params
    );
  }
  GetJournalVochersReport_HeadsById(params) {
    return axiosTokenService.post(
      final_url + "GetJournalVochersReport_HeadsById",
      params
    );
  }
  //Rani ADDED
  getjournalpdf(payment_receipt_id) {
    return axiosTokenService.get(final_url + "trailBalacePdf", {
      responseType: "blob",
      params: { payment_receipt_id: payment_receipt_id }
    });
  }


  //HeadWISE
  headerwisetabledata(params) {
    return axiosTokenService.post(
      final_url + "GetHeadWise_Details_Report",
      params
    );
  }
  GetCashBank_All_JV_Reportheadwise(params) {
    return axiosTokenService.post(
      final_url + "GetCashBank_All_JV_Reportheadwise",
      params
    );
  }
  GetCashBank_Receipts_PaymentsReportheadwise(params) {
    return axiosTokenService.post(
      final_url + "GetCashBank_Receipts_PaymentsReportheadwise",
      params
    );
  }

  //SUBLEDGER
  GetSubLeadger_Report(params) {
    return axiosTokenService.post(final_url + "GetSubLeadger_Report", params);
  }
  //JOURNAL REGISTER
  GetJournalRegister_Report(params) {
    return axiosTokenService.post(
      final_url + "GetJournalRegister_Report",
      params
    );
  }
  getPaymentDataForReceiptHeads(param1) {
    return axiosTokenService.post(
      final_url + "getPaymentDataForReceiptHeads",
      param1
    );
  }
  //GENERAL LEDGER
  GetGeneralLeadger_Report(params) {
    return axiosTokenService.post(
      final_url + "GetGeneralLeadger_Report",
      params
    );
  }
  GetGeneralLeadgerReportOB(params) {
    return axiosTokenService.post(
      final_url + "GetGeneralLeadgerReportOB",
      params
    );
  }


  //EXPENDITURE
  GetExpenditureAnalaysis_Report(params) {
    return axiosTokenService.post(
      final_url + "GetExpenditureAnalaysis_Report",
      params
    );
  }
  GetExpenditureAnalaysis_OnClick_Exp(params) {
    return axiosTokenService.post(
      final_url + "GetExpenditureAnalaysis_OnClick_Exp",
      params
    );
  }
  GetExpenditureAnalaysis_OnClick_Headid(params) {
    return axiosTokenService.post(
      final_url + "GetExpenditureAnalaysis_OnClick_Headid",
      params
    );
  }
  GetExpenditureAnalaysis_OnClick_Exp_all(params) {
    return axiosTokenService.post(
      final_url + "GetExpenditureAnalaysis_OnClick_Exp_all",
      params
    );
  }
  //=========================>Review Reports<=========================================

  //http://172.17.205.53:8082/ofmsapi/GetReviewReport

  TrailBalanceReportWithOBs(params) {
    return axiosTokenService.post(final_url + "TrailBalanceReportWithOBs", params);
  }

  GetReviewReport(params) {
    return axiosTokenService.post(final_url + "GetReviewReport", params);
  }

  GetReviewReport1(params1) {
    return axiosTokenService.post(
      final_url + "GetReviewReport_In_Exp",
      params1
    );
  }

  GetReviewReport2(params2) {
    return axiosTokenService.post(
      final_url + "GetReviewReport_In_Exp",
      params2
    );
  }
  trailBalacePdf(payment_receipt_id) {
    return axiosTokenService.get(final_url + "trailBalacePdf", {
      responseType: "blob",
      params: { payment_receipt_id: payment_receipt_id }
    });
  }
  GetReviewReport_In_Exp_State(param1) {
    return axiosTokenService.post(final_url + "GetReviewReport_In_Exp", param1);
  }

  GetReviewReport_In_Exp2(param2) {
    return axiosTokenService.post(final_url + "GetReviewReport", param2);
  }

  //http://172.17.205.53:8082/ofmsapi/GetReviewReport_In_Exp

  GetReviewReport_In_Exp(params) {
    return axiosTokenService.post(final_url + "GetReviewReport_In_Exp", params);
  }

  GetReviewReport_In_Exp1(param1) {
    return axiosTokenService.post(final_url + "GetReviewReport_In_Exp", param1);
  }

  GetReviewReport_In_Exp_Dist_Inc(param2) {
    return axiosTokenService.post(final_url + "GetReviewReport_In_Exp", param2);
  }

  GetReviewReport_In_Exp_Dist_Exp(param3) {
    return axiosTokenService.post(final_url + "GetReviewReport_In_Exp", param3);
  }

  //http://172.17.205.53:8082/ofmsapi/GetReviewReport_OnClick

  GetReviewReport_OnClick(params) {
    return axiosTokenService.post(
      final_url + "GetReviewReport_OnClick",
      params
    );
  }
  //RECEIPTS/PAYEMNTS CB
  recieptsPayments(params) {
    return axiosTokenService.post(
      final_url + "GetPayments_Receips_CashBank_Report",
      params
    );
  }
  recieptsPayments1(param1) {
    return axiosTokenService.post(
      final_url + "GetPayments_Receips_CashBank_Report",
      param1
    );
  }
  //SAALRY ONLINE JV REPORT
  GetSalary_OnlineJV_Report_Coulmns(params) {
    return axiosTokenService.post(
      final_url + "GetSalary_OnlineJV_Report_Coulmns",
      params
    );
  }

  GetSalary_OnlineJV_Report_Values(param1) {
    return axiosTokenService.post(
      final_url + "GetSalary_OnlineJV_Report_Values",
      param1
    );
  }
  Months_Drop_Down() {
    return axiosTokenService.get(final_url + "Months_Drop_Down");
  }
  years_Drop_Down() {
    return axiosTokenService.get(final_url + "years_Drop_Down");
  }

  //Payroll Reports
  fetchEmptypeList() {
    return axiosTokenService.get(final_url + "EmployeeTypeDropDown");
  }

  ConfirmEmp_OnRolls_Report(params) {
    return axiosTokenService.post(
      final_url + "ConfirmEmp_OnRolls_Report",
      params
    );
  }

  ConfirmEmp_WorkStatus_Report(params) {
    return axiosTokenService.put(
      final_url + "ConfirmEmp_WorkStatus_Report",
      params
    );
  }

  ConfirmEmp_EmpName_Report(params) {
    return axiosTokenService.post(
      final_url + "ConfirmEmp_EmpName_Report",
      params
    );
  }
  ConfirmEmp_Update_Report1(param1) {
    return axiosTokenService.put(
      final_url + "ConfirmEmp_Update_Report",
      param1
    );
  }
  ConfirmEmp_Update_Report3(param3) {
    return axiosTokenService.put(
      final_url + "ConfirmEmp_Update_Report",
      param3
    );
  }
  ConfirmEmp_Update_Report4(param4) {
    return axiosTokenService.put(
      final_url + "ConfirmEmp_Update_Report",
      param4
    );
  }
  UpdateEmployeesToType125(params) {
    return axiosTokenService.post(final_url + "UpdateEmployeesToType125", params);
  }
  //2ND PAYROLL GENERATION OF MONHTLY PAYBILL

  MonthlyPaybillConfirmation(params) {
    return axiosTokenService.post(final_url + "EmployeeConfirmation", params);
  }
  //3RD PAYROLL REPORT
  GetMonthlyPayBillDetails_Generated(values) {
    return axiosTokenService.post(
      final_url + "GetMonthlyPaybillConfirmationReport_PaybillGenerated",
      values
    );
  }
  GetMonthlyPayBillDetails_AfterConfirm(values) {
    return axiosTokenService.post(
      final_url + "GetMonthlyPaybillConfirmationReport_AfterConfirm",
      values
    );
  }
  GetMonthlyPayBillDetails_BeforeConfirm(values) {
    return axiosTokenService.post(
      final_url + "GetMonthlyPaybillConfirmationReport_beforeConfirm",
      values
    );
  }
  confirm_UpdatList(values) {
    return axiosTokenService.put(final_url + "confirm_UpdatList", values);
  }
  paybillconfirm_UpdatList(values) {
    return axiosTokenService.put(
      final_url + "paybillconfirm_UpdatList",
      values
    );
  }
  GetMonthlyPayBillDetails(values) {
    return axiosTokenService.post(
      final_url + "GenertedMonthlyPaybill_Report",
      values
    );
  }
  //PAYBILL REPORT IN GMADM LOGIN

  PaybillReport(values) {
    return axiosTokenService.post(
      final_url + "PaybillReport",
      values
    );
  }
  // EMPLOYEE DATA COUNT REPORT

  DistrictsPayBill() {
    return axiosTokenService.get(
      final_url + "DistrictsPayBill",

    );
  }
  UpdateDistrictsPayBillCount(updatedData) {
    return axiosTokenService.post(
      final_url + "UpdateDistrictsPayBillCount",
      updatedData
    );
  }
  //EMPLOYEE PAY PARTICLURS 4TH
  fetchMonthList() {
    return axiosTokenService.get(final_url + "MonthsDropDown");
  }
  fetchYearList() {
    return axiosTokenService.get(final_url + "YearsDropDown");
  }

  fetchEmployeeName(emptype_id) {
    return axiosTokenService.get(final_url + "getEmpNamesbyType/" + emptype_id);
  }
  getEmpNamesbyTypeandDistrict(params) {
    return axiosTokenService.post(
      final_url + "getEmpNamesbyTypeandDistrict",
      params
    );
  }

  getAllEmployeesbyType(params) {
    return axiosTokenService.post(
      final_url + "getAllEmployeesbyType",
      params
    );
  }


  getEmployeePayParticularsReport(values) {
    return axiosTokenService.post(
      final_url + "empPayParticluarsReport",
      values
    );
  }
  getEmp_paypdf(values) {
    return axiosTokenService.post(final_url + "getEmp_paypdf", values);
  }
  emp_pay_particulars_pdf(values) {
    return axiosTokenService.post(
      final_url + "getMonthly_Paybill_Pdf",
      values, // Pass the values directly in the request body
      {
        responseType: "blob"
      }
    );
  }

  generatePayslipForEmployees(updatedList) {
    return axiosTokenService.post(
      final_url + "generatePayslipForEmployees",
      updatedList, // Pass the values directly in the request body
      {
        responseType: "blob"
      }
    );
  }
  //Variation Paybill
  VariationCalPaybill(params) {
    return axiosTokenService.post(final_url + "VariationCalPaybill", params);
  }

  //APSCHLC LOGIN ENTRY FORMS
  HeadsDetails() {
    return axiosTokenService.get(final_url + "HeadsDetails");
  }
  classificationDropdown() {
    return axiosTokenService.get(final_url + "classificationDropdown");
  }
  HeadMasterActions(param1) {
    return axiosTokenService.post(final_url + "HeadMasterActions", param1);
  }


  //APSHCL LOGIN REPORTS
  // BANK BALANCES REPORT
  BankBalancesReport() {
    return axiosTokenService.get(final_url + "BankBalancesReport");
  }
  UpdateOnYes(params) {
    return axiosTokenService.put(final_url + "ClickingOnYes", params);
  }
  //APSHCL BANK BOOK REPORT
  bankbook_fromdate_todate(params) {
    return axiosTokenService.post(final_url + "BankBookReport_Apshcl", params);
  }
  fetchAccountNo(params) {
    return axiosTokenService.post(final_url + "AccountNoDropDown", params);
  }
  //GMF LOGIN ENTRY FORMS
  //DISTRICT BUDGET LIMITS
  DistrictsBudgetLimits() {
    return axiosTokenService.get(final_url + "DistrictsBudgetLimits");
  }
  HeadOfficeBudgetLimits() {
    return axiosTokenService.get(final_url + "HeadOfficeBudgetLimits");
  }
  UpdateDistrictBudgetLimits(updatedData) {
    return axiosTokenService.post(
      final_url + "UpdateDistrictBudgetLimits",
      updatedData
    );
  }
  UpdateHeadsBudgetLimits(updatedHeadsData) {
    return axiosTokenService.post(
      final_url + "UpdateDistrictBudgetLimits",
      updatedHeadsData
    );
  }
  //GMF LOGIN reports
  GetDeletePRJ(params) {
    return axiosTokenService.post(
      final_url + "GetDeletePRJ",
      params
    );
  }
  //BANK BOOK CONFIRMATION
  GetBankDetailsToBeConfirmByGmf(params) {
    return axiosTokenService.post(
      final_url + "GetBankDetailsToBeConfirmByGmf",
      params
    );
  }
  UpdateBankDetainlsConfirm(requestBody) {
    return axiosTokenService.post(
      final_url + "UpdateBankDetainlsConfirm",
      requestBody
    );
  }
  //DISTRICT Date LIMITS
  DistrictBudgetDateLimits() {
    return axiosTokenService.get(final_url + "DistrictBudgetDateLimits");
  }
  UpdateDistrictDateLimits(updatedData) {
    return axiosTokenService.post(
      final_url + "UpdateDistrictDateLimits",
      updatedData
    );
  }
  //EmployeeConfirmation
  EmployeeConfirmation(params) {
    return axiosTokenService.post(final_url + "EmployeeConfirmation", params);
  }
  UpdateEmpdetailsConfirm(requestBody) {
    return axiosTokenService.post(
      final_url + "UpdateEmpdetailsConfirm",
      requestBody
    );
  }

  //APPROVALS
  Generation_Receipt_Managerapproval(params) {
    return axiosTokenService.post(
      final_url + "generationReceiptManagerApproval",
      params
    );
  }
  Generation_Payment_Managerapproval(params) {
    return axiosTokenService.post(
      final_url + "Generation_Payment_Managerapproval",
      params
    );
  }
  GetSubHeadsDataforGR_Manger(params) {
    return axiosTokenService.post(
      final_url + "GetSubHeadsDataforGR_Manger",
      params
    );
  }
  GetDataforBankEntnry_Manger() {
    return axiosTokenService.get(final_url + "GetDataforBankEntnry_Manger");
  }
  GetDataforGR_Manger() {
    return axiosTokenService.get(final_url + "GetDataforGR_Manger");
  }
  GetDataforGP_Manger() {
    return axiosTokenService.get(final_url + "GetDataforGP_Manger");
  }
  GetDataforGJ_Manger() {
    return axiosTokenService.get(final_url + "GetDataforGJ_Manger");
  }
  GetDataforGJ_Edit() {
    return axiosTokenService.get(final_url + "GetDataforGJ_Edit");
  }
  GetJV_Edit_data(params) {
    return axiosTokenService.post(final_url + "GetJV_Edit_data", params);
  }

  GetSubHeadsDataforGJ_Manger(params) {
    return axiosTokenService.post(
      final_url + "GetSubHeadsDataforGJ_Manger",
      params
    );
  }

  // HOUSING REPORT GRAMIN STAGE UPDATION

  districtlist() {
    return axiosTokenServiceKeyCloak.get(housing_url + "common/DistrictDropdown");
  }
  // getPhase() {
  //   return axiosTokenServiceKeyCloak.get(housing_url + "Phase");
  // }
  getScheme() {
    return axiosTokenServiceKeyCloak.get(housing_url + "Shceme");
  }
  // getCaste() {
  //   return axiosTokenServiceKeyCloak.get(housing_url + "Caste");
  // }

  getPhase() {
    return axiosTokenServiceKeyCloak.get(housing_url + "common/PhasesMasterDropdown");
  }

  getCaste() {
    return axiosTokenServiceKeyCloak.get(housing_url + "common/CasteDropdown");
  }

  Ofms_Expenditure(params) {
    return axiosTokenServiceKeyCloak.post(housing_url + "ofms_reports/Ofms_Expenditure", params);
  }
  getStageDrillDown(params) {
    return axiosTokenServiceKeyCloak.post(
      housing_url + "Ofms_Stagedrilldown?fromdate",
      params
    );
  }

  //INcome housing
  Ofms_Income(params) {
    return axiosTokenServiceKeyCloak.post(housing_url + "ofms_reports/Ofms_Income", params, {
      headers: { "Content-Type": "application/json" }
    });
  }
  schemelist() {
    return axiosTokenServiceKeyCloak.get(housing_url + "aadhar_Mapped/getschemsdropdown");
  }

  //APHOMES
  AphomesBenfPaymentReport(params) { return axiosTokenServiceKeyCloak.post(housing_url + `Aphomes_BenPay/AphomesBenfPaymentReport`, params); }

  AphomesDistrictMaster(params) { return axiosTokenServiceKeyCloak.post(housing_url + `Aphomes_BenPay/AphomesDistrictMaster`, params); }

  getAphomesPhasesDropdown() { return axiosTokenServiceKeyCloak.get(housing_url + `Aphomes_BenPay/getAphomesPhasesDropdown`); }

  getAphomesSchemesDropdown() { return axiosTokenServiceKeyCloak.get(housing_url + `Aphomes_BenPay/getAphomesSchemesDropdown`); }

  AphomesPaymentCementReleasedReport(params) { return axiosTokenServiceKeyCloak.post(housing_url + `Aphomes_BenPay/AphomesPaymentCementReleasedReport`, params); }


  Ofms_StageupdationReport(params) { return axiosTokenServiceKeyCloak.post(housing_url + "Ofms_StageupdationReport", params); }
  DistDivConstMandlBasedVillages(dist_code, div_code, cont_code, mandal_code) {
    return axiosTokenServiceKeyCloak.get(
      housing_url +
      `common/DistDivConstMandlBasedVillages?dist_code=${dist_code}&div_code=${div_code}&cont_code=${cont_code}&mandal_code=${mandal_code}`
    );
  }

  getNPIArchPaymentReport(params) {
    return axiosTokenServiceKeyCloak.post(
      housing_url + "npi_Arch/getNPIArchPaymentReport",
      params
    );
  }

  getNPIArchPaymentReportBenDetails(params) {
    return axiosTokenServiceKeyCloak.post(
      housing_url + "npi_Arch/getNPIArchPaymentReportBenDetails",
      params
    );
  }

  getPeriodsdropdown() {
    return axiosTokenServiceKeyCloak.get(housing_url + "phy_Progress/Periodsdropdown");
  }

  getContractorsDropdown() {
    return axiosTokenServiceKeyCloak.get(housing_url + `common/getContrctorsDropdown`);
  }

  //BRS APSHCL
  getBanks_Brs() {
    return axiosTokenServiceKeyCloak.get(final_url + "getBanks_Brs");
  }
  getBRS_BBU(params) {
    return axiosTokenServiceKeyCloak.post(final_url + "getBRS_BBU", params);
  }
  //GST APUS HOUSING
  GstmaterialPathcDetails_dates(params) {
    return axiosTokenServiceKeyCloak.post(
      housing_url + "GstmaterialPathcDetails",
      params
    );
  }

  GstmaterialTypecDetails(params) {
    return axiosTokenServiceKeyCloak.post(
      housing_url + "GstmaterialTypecDetails",
      params
    );
  }

  //GMADM
  GetDistrictwiseTransferData(params) {
    return axiosTokenService.post(
      final_url + "GetDistrictwiseTransferData",
      params
    );
  }
  UpdateDistrictwiseTransferData(param) {
    console.log("param", param)
    return axiosTokenService.post(
      final_url + "UpdateDistrictwiseTransferData",
      param
    );
  }
  //GMADM PAYROLL DistrictwiseDesignationCount
  DistrictwiseDesignationCount(values) {
    return axiosTokenService.post(
      final_url + "DistrictwiseDesignationCount",
      values
    );
  }
  //housing
  BenfMappedToAgencyReport(params) {
    return axiosTokenServiceKeyCloak.post(housing_url + "BenfMappedToAgencyReport", params);
  }
  BenfMappedToAgencyBensReport(params) {
    return axiosTokenServiceKeyCloak.post(housing_url + "BenfMappedToAgencyBensReport", params);
  }
  // new employee registration 

  NewEmpRegistration3(param3) {
    return axiosTokenService.post(
      final_url + "NewEmpRegistration",
      param3
    );
  }
  NewEmpRegistration4(param4) {
    return axiosTokenService.post(
      final_url + "NewEmpRegistration",
      param4
    );
  }
  NewEmpRegistration125(param125) {
    return axiosTokenService.post(
      final_url + "NewEmpRegistration",
      param125
    );
  }
  //PhysicalProgressReport
  getNPIArchPaymentSchemewiseReport(params) {
    return axiosTokenServiceKeyCloak.post(housing_url + "getNPIArchPaymentSchemewiseReport", params)
  }
  getAphomesSchemesPhasesReport(params) {
    return axiosTokenServiceKeyCloak.post(housing_url + "ofms_reports/getAphomesSchemesPhasesReport", params)
  }
  keycloaktokengeneration() {
    return axiosTokenService.post(final_url + "keycloaktokengeneration");
  }
  //BankResponseFilesUpload vinay bahrgavi
  getrefno(params) { //BankResponsefileUploadController
    return axiosTokenService.post(final_url + "bankResaponse_File/getrefno", params);
  }

  bankuploadcsv(params) { //BankResponsefileUploadController
    return axiosTokenService.post(final_url + "bankResaponse_File/upload-file", params);
  }
  responsefilehandleUpdates(params) { //responsefilehandleUpdates
    return axiosTokenService.post(final_url + "bankResaponse_File/responsefilehandleUpdates", params);
  }
  UpdatePaymentstatusbycbsuser(params) { //BankResponsefileUploadController
    return axiosTokenService.post(final_url + "bankResaponse_File/process-payment-status", params);
  }

  getsubmit(params) { //BankResponsefileUploadController
    return axiosTokenService.post(final_url + "bankResaponse_File/getsubmit", params);
  }
  //BankResponseFilesUpload vinay bahrgavi

  //PFMSReleaseStatusReport vinay bahrgavi
  getSubmitdetailsreport(params) { //BankResponsefileUploadController
    return axiosTokenService.post(final_url + "bankResaponse_File/getSubmitdetailsreport", params);
  }
  //PFMSReleaseStatusReport vinay bahrgavi




  getEmployeeDetailsById(params) {
    return axiosTokenService.post(final_url + "getEmployeeDetailsById", params);
  }

  updateEmployeeDetailsType4(params) {
    return axiosTokenService.post(final_url + "updateEmployeeDetailsType4", params);
  }

  updateEmployeeDetailsType3(params) {
    return axiosTokenService.post(final_url + "updateEmployeeDetailsType3", params);
  }

  updateEmployeeDetailsType125(params) {
    return axiosTokenService.post(final_url + "updateEmployeeDetailsType125", params);
  }

  updateEmployeeDetailsToReg(params) {
    return axiosTokenService.post(final_url + "updateEmployeeDetailsToReg", params);
  }
  getGmfBudgetLimitsDistricts() {
    return axiosTokenService.get(final_url + "getGmfBudgetLimitsDistricts");
  }

  getGmfBudgetLimitsHod() {
    return axiosTokenService.get(final_url + "getGmfBudgetLimitsHod");
  }

  updatePresentGmfBudgetLimits(params) {
    return axiosTokenService.post(final_url + "updatePresentGmfBudgetLimits", params);
  }
  getSubHeadsForSubheadLedger(params) {
    return axiosTokenService.post(final_url + "getSubHeadsForSubheadLedger", params);
  }


  fileUploadUrl(params) {
    return axiosTokenServiceKeyCloak.post(`${cloud_url}/apofms/Pay_Rec`, params)
  }

  fileUploadUrlJV(params) {
    return axiosTokenServiceKeyCloak.post(`${cloud_url}/apofmslive/journalentry`, params)
  }

  brsfileUploadUrl(params) {
    return axiosTokenServiceKeyCloak.post(`${cloud_url}/apofms/BRS`, params)
  }
  getEmployeesData() {
    return axiosTokenService.get(final_url + "getEmployeesData");
  }

  getRetiredEmployees() {
    return axiosTokenService.get(final_url + "getRetiredEmployees");
  }
  getDistWiseEmployeesData() {
    return axiosTokenService.get(final_url + "getDistWiseEmployeesData");
  }

  getEmployeeTypeData() {
    return axiosTokenService.get(final_url + "getEmployeeTypeData");
  }
  getDesignationWiseEmployeesData() {
    return axiosTokenService.get(final_url + "getDesignationWiseEmployeesData");
  }


  getEmployeeStatusData() {
    return axiosTokenService.get(final_url + "getEmployeeStatusData");
  }

  OTSreconsolationreport(params) {
    return axiosTokenServiceKeyCloak.post(housing_url + "progressadd/financeotsexp", params)
  }
  getSchemeMaster(params) {
    return axiosTokenServiceKeyCloak.get(housing_url + "secprogress/getSchemeMaster", params)
  }
  financeaddtionalexp(params) {
    return axiosTokenServiceKeyCloak.post(housing_url + "progressadd/financeaddtionalexp", params);
  }
  financeotsexponclick(params) {
    return axiosTokenServiceKeyCloak.post(housing_url + "progressadd/financeotsexponclick", params);
  }

  obheadsdata() {
    return axiosTokenService.get(final_url + "obheadsdata");
  }

  openeningBalanceHeadsData(params) {
    return axiosTokenService.post(final_url + "openeningBalanceHeadsData", params);
  }

  insertopeneningBalanceHeadsData(params) {
    return axiosTokenService.post(final_url + "insertopeneningBalanceHeadsData", params);
  }

  editHeadsDebitCreditAmount(params) {
    return axiosTokenService.post(final_url + "editHeadsDebitCreditAmount", params);
  }

  getSubheads(params) {
    return axiosTokenService.post(final_url + "getSubheads", params);
  }

  insertopeneningBalanceSubHeadsData(params) {
    return axiosTokenService.post(final_url + "insertopeneningBalanceSubHeadsData", params);
  }
  MGNREGAPaymentStatusReport(params) {
    return axiosTokenServiceKeyCloak.get(housing_url + "ofms_reports/MGNREGAPaymentStatusReport", params);
  }

  getAllbalancesheet(params) {
    return axiosTokenService.get(final_url + "balancesheet/getAllbalancesheet", params);
  }


  getBRSBankBookUpdate(params) {
    return axiosTokenService.post(final_url + "getBRSBankBookUpdate", params);
  }

  BankBookUpdateInsertion(params) {
    return axiosTokenService.post(final_url + "BankBookUpdateInsertion", params);
  }

  getBRSOutstanding(params) {
    return axiosTokenService.post(final_url + "getBRSOutstanding", params);
  }

  getBankACAsperEnteries(params) {
    return axiosTokenService.post(final_url + "getBankACAsperEnteries", params);
  }

  BankReconciliationStatement(params) {
    return axiosTokenService.post(final_url + "BankReconciliationStatement", params);
  }

  DirectCreditDebitInsertion(params) {
    return axiosTokenService.post(final_url + "DirectCreditDebitInsertion", params);
  }

  getBalanceSheetData(params) {
    return axiosTokenService.post(final_url + "auditreports/getBalanceSheetData", params);
  }
  BalanceSheetNotenoDataOBNoteno(params) {
    return axiosTokenService.post(final_url + "auditreports/BalanceSheetNotenoDataOBNoteno", params);
  }

  BalanceSheetNotenoDataOB(params) {
    return axiosTokenService.post(final_url + "auditreports/BalanceSheetNotenoDataOB", params);
  }
  BalanceSheetNotenoDataNet(params) {
    return axiosTokenService.post(final_url + "auditreports/BalanceSheetNotenoDataNet", params);
  }
  getBudgetControlSystemByDateApi() {
    return axiosTokenService.get(final_url + "getBudgetControlSystemByDateApi");
  }
  updateBudgetControlSystemByDateApi(params) {
    return axiosTokenService.post(final_url + "updateBudgetControlSystemByDateApi", params);
  }

  OBMasterHeads(params) {
    return axiosTokenService.post(final_url + "OBMasterHeads", params);
  }

  getHeadidDebitCredit(params) {
    return axiosTokenService.post(final_url + "getHeadidDebitCredit", params);
  }
  ProfitandLossStatment(params) {
    return axiosTokenService.post(final_url + "auditreports/ProfitandLossStatment", params);
  }
  ProfitandLossStatmentPeriod(params) {
    return axiosTokenService.post(final_url + "auditreports/ProfitandLossStatmentPeriod", params);
  }
  ProfitandLossStatmentPeriodforNoteno(params) {
    return axiosTokenService.post(final_url + "auditreports/ProfitandLossStatmentPeriodforNoteno", params);
  }

  getCaptcha() {
    return axiosWithOutToken.get(final_url + "api/captcha");
  }
}

export default new HousingService();


